
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13130',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13130",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.491",
  "data-fetching-client": "static-1.9908",
  "foundations-components": "static-1.8394",
  "foundations-components-legacy": "static-1.1419",
  "foundations-theming": "static-1.4711",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8278",
  "hub-http-shared-msw-handlers": "static-1.10534",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11735",
  "I18n": "static-7.1663",
  "jasmine-runner": "static-1.6700",
  "marketplace-discovery-studio-lib": "static-1.558",
  "marketplace-storefront-base": "static-1.13193",
  "quartz": "static-1.7375",
  "react-dlb": "static-1.85",
  "react-rhumb": "static-1.16963",
  "reactive-variable-buffer-atom": "static-1.3107",
  "reporting-testing-lib": "static-1.10542",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12773",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7566",
  "ui-addon-i18n": "static-1.11396",
  "ui-addon-react-router-dom": "static-1.9789",
  "unified-auth": "static-1.814",
  "unified-auth-core-lib": "static-1.1096",
  "usage-tracker": "static-1.7608",
  "usage-tracker-core": "static-1.7458",
  "customer-data-property-utils": "static-1.8350",
  "hub-http": "static-1.6465",
  "integrations-lib": "static-1.16936",
  "marketplace-ui-common": "static-1.20614",
  "marketplace-ui-install": "static-1.600",
  "property-management-iframe": "static-1.14006",
  "quartz-config": "static-1.1153",
  "quartz-core": "static-1.6594",
  "quartz-routing": "static-1.805",
  "quick-fetch": "static-1.4098",
  "react": "static-7.191",
  "rpc-client-utils": "static-1.4915",
  "ts-schema": "static-1.4259",
  "ui-universal-auth": "static-1.9300",
  "UIComponents": "static-3.8681",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3582",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3652",
  "quartz-webpack": "static-1.3599",
  "bend-plugin-quartz-routing": "static-1.453",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4663",
  "floating-ui": "static-1.62",
  "foundations-assets": "static-1.5131",
  "foundations-theming-specialty": "static-1.2427",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9678",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.63",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5520",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.495",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2486",
  "ui-fonts": "static-1.997",
  "ui-images": "static-2.1230",
  "bend-plugin-foundations-theming": "static-1.3194",
  "foundations-theming-base": "static-1.3696",
  "stylex": "static-1.38",
  "HeadJS": "static-2.790",
  "hs-test-utils-bend-plugin": "static-1.3389",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4569",
  "ui-addon-video-player": "static-1.8955",
  "ai-components-ui-library": "static-1.9601",
  "ai-rendering-library": "static-1.11012",
  "chirp-fetch": "static-1.2144",
  "connections-embed-lib": "static-1.1435",
  "copilot-toolkit": "static-1.11755",
  "feedback-loader": "static-1.29740",
  "laboratory-lib": "static-3.7404",
  "marketplace-embed": "static-1.22828",
  "marketplace-ui-details": "static-1.10509",
  "marketplace-ui-reviews": "static-1.20569",
  "marketplace-ui-tracking": "static-1.14784",
  "sanitize-text": "static-1.8402",
  "usage-tracker-multi": "static-1.6022",
  "usage-tracker-session-replay": "static-1.5294",
  "wootric-nps": "static-1.7165",
  "quartz-head": "static-1.1040",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4910",
  "immer": "static-1.94",
  "immerable": "static-1.4403",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2652",
  "reporting-data": "static-1.68609",
  "cssUtils": "static-1.872",
  "flux-actions": "static-1.360",
  "HubStyle": "static-2.12042",
  "PatternValidationJS": "static-1.3149",
  "react-colorpicker": "static-2.10460",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10618",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7598",
  "icons": "static-2.674",
  "marketplace-ui-apps-core": "static-1.19146",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4763",
  "foundations-components-test-utils": "static-1.5877",
  "quartz-i18n": "static-1.1050",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.362",
  "ads-unified-auth-lib": "static-1.1081",
  "google-sheets-integration-lib": "static-1.939",
  "microsoft-drive-auth-lib": "static-1.32",
  "surveymonkey-integration-lib": "static-1.383",
  "slack-ui-library": "static-1.10650",
  "fsm": "static-1.3992",
  "customer-data-objects": "static-1.7938",
  "property-translator": "static-1.5648",
  "hs-locale-management": "static-1.259",
  "frontend-preferences-client": "static-1.8180",
  "hs-promise-utils": "static-1.5849",
  "hubspot-apollo-client": "static-1.5131",
  "integrations-error-boundary-lib": "static-1.14351",
  "integrations-tracking-lib": "static-1.5860",
  "native-integrations-shared-strings": "static-1.8029",
  "sanitize": "static-1.4728",
  "superstore": "static-1.5009",
  "ui-shepherd-react": "static-3.10516",
  "ai-settings-ui-library": "static-1.8263",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4829",
  "immutable-less": "static-1.4903",
  "marketplace-ui-client-types": "static-1.18021",
  "nav-meta": "static-1.30358",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18324",
  "ui-product-approvals-common": "static-1.889",
  "ai-studio-lib": "static-1.12368",
  "hubspot-prosemirror": "static-1.18880",
  "integrations-reconnect-lib": "static-1.408",
  "ui-addon-iframeable": "static-1.9327",
  "ui-addon-integrations-directory-panel": "static-2.8278",
  "ui-product-approvals": "static-1.28994",
  "ui-tool-access": "static-1.10405",
  "inbound-db-properties-service-client": "static-1.4023",
  "property-management-common": "static-1.6294",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.567",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1050",
  "quartz-test": "static-1.1050",
  "quartz-tracking": "static-1.754",
  "trellis-components": "static-1.2505",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.325",
  "bender-build-tools": "static-1.3382",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22667",
  "ContentUtils": "static-1.69063",
  "customer-data-objects-ui-components": "static-1.13281",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2749",
  "breeze-engine-core": "static-1.860",
  "breeze-onboarding-components": "static-1.624",
  "customer-data-filters-ui": "static-1.40775",
  "customer-data-reference-ui-components": "static-1.13432",
  "embedded-academy-lib": "static-1.15382",
  "ExportDialog": "static-6.10631",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41923",
  "reporting-snowflake": "static-1.57227",
  "reporting-ui-components": "static-2.65880",
  "reporting-visualizations": "static-1.60685",
  "trial-components-library": "static-1.14029",
  "trellis-theming": "static-1.1215",
  "ui-addon-teams": "static-1.21857",
  "upgrade-components-lib": "static-1.460",
  "magpie-lib": "static-1.5722",
  "navigation-components": "static-1.18721",
  "breeze-engine-lib": "static-1.1582",
  "magpie-types": "static-1.5182",
  "simple-logging-lib": "static-1.3303",
  "fail-safe": "static-1.207",
  "app-governance-lib": "static-1.2303",
  "developer-experience-shared-components": "static-1.10753",
  "purchase-motions-components": "static-1.6289",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10056",
  "usage-tracker-anonymous": "static-1.6025",
  "usage-tracker-public": "static-1.7419",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3951",
  "reference-resolvers": "static-1.8433",
  "ui-extensibility-client-types": "static-1.4173",
  "hubspot-apollo-cache": "static-1.590",
  "universal-page-editor-lib": "static-1.3261",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3444",
  "atom": "static-1.5338",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.99",
  "react-codemirror": "static-1.10891",
  "ui-addon-draggable": "static-3.5007",
  "content-assistance-lib": "static-1.8139",
  "content-media-capture": "static-1.5321",
  "customer-data-ui-utilities": "static-1.10079",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24368",
  "growth-payments-core": "static-1.26083",
  "knowledge-content-types": "static-1.8621",
  "payment-link-components": "static-1.24087",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20241",
  "ui-addon-emoji-picker": "static-1.10136",
  "ui-business-units-lib": "static-1.9335",
  "video-components-external": "static-1.12071",
  "video-data-lib": "static-1.35729",
  "navigation-messaging": "static-1.8048",
  "collaboration-sidebar": "static-1.58621",
  "react-dnd-compat": "static-1.4867",
  "batch-promise": "static-1.1794",
  "crm-component-utils": "static-1.39741",
  "crm-properties-common-lib": "static-1.6142",
  "customer-data-properties": "static-1.52448",
  "external-options-client-types": "static-1.4305",
  "framework-data-schema-resolvers": "static-1.7144",
  "property-value-citations": "static-1.3062",
  "reference-resolvers-lite": "static-1.8352",
  "hubspotter-http-shared-msw-handlers": "static-1.10532",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5067",
  "content-icons-ui": "static-1.2316",
  "breeze-artifacts-sdk": "static-1.201",
  "onboarding-journeys-lib": "static-1.787",
  "pulse": "static-1.878",
  "conversations-skeleton-state": "static-1.7500",
  "crm-message-bus": "static-1.43651",
  "customer-data-filters-ui-msw-helpers": "static-1.23210",
  "events-data-lib": "static-1.494",
  "FormUrlGenerator": "static-2.4978",
  "framework-builder-read-service-client": "static-1.4186",
  "hs-resources": "static-1.443",
  "multi-account-reference-resolvers": "static-1.1247",
  "onboarding-scopes": "static-1.6707",
  "onboarding-tours": "static-1.17046",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14377",
  "academy-common-lib": "static-1.14842",
  "dashboard-lib": "static-1.82642",
  "getting-started-shared-tasks": "static-1.19124",
  "hubspot-prosemirror-plugins": "static-1.18872",
  "share-with-third-party-component-lib": "static-1.8957",
  "ui-asset-management-lib": "static-1.11348",
  "user-context": "static-1.5366",
  "reporting-plugins": "static-1.10674",
  "reporting-reports": "static-1.68287",
  "hubs-service-types": "static-1.1510",
  "purchase-motions-api": "static-1.6292",
  "signup-constants": "static-1.19513",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.973",
  "nest": "static-1.487",
  "breeze-engine-chat-components": "static-1.560",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.158",
  "framework-listing-lib": "static-2.29386",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31340",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4507",
  "signup-ui-url-generator": "static-2.8312",
  "onboarding-tours-client": "static-1.5260",
  "one-click-checkout": "static-1.315",
  "platform-infra-nav-components": "static-1.7853",
  "subscription-experience-data-types": "static-1.15206",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.9998",
  "redux-thunk": "static-2.77",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29223",
  "content-media-composition-data-lib": "static-1.13125",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4677",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.634",
  "ui-addon-opt": "static-4.8617",
  "commerce-tours-lib": "static-1.6542",
  "growth-onboarding-reliability": "static-1.5333",
  "sales-checkout-service-client": "static-1.3779",
  "data-token-picker": "static-1.16820",
  "FileManagerLib": "static-1.40008",
  "content-media-compositions": "static-2.17132",
  "media-bridge-lib": "static-1.19343",
  "chatspot-widget-iframe": "static-1.22658",
  "collaboration-sidebar-common": "static-1.3418",
  "marketing-platform-lib": "static-1.7121",
  "card-properties-lib": "static-1.44913",
  "commerce-subscription-lib": "static-1.37687",
  "crm-actions": "static-1.6604",
  "crm-cards-sdk": "static-1.44395",
  "customer-data-properties-shared-msw-handlers": "static-1.9861",
  "customer-data-tracking": "static-1.7133",
  "calling-global-api": "static-1.65387",
  "calling-internal-common": "static-1.31569",
  "calling-lifecycle-internal": "static-1.66769",
  "calling-lifecycle-messages": "static-1.59063",
  "commerce-products-lib": "static-1.10417",
  "conditional-properties-service-client": "static-1.3980",
  "crm-index-visualization-core": "static-1.4482",
  "crm-links": "static-1.6576",
  "crm-pipelines-api-client-types": "static-1.4314",
  "formula-editor": "static-1.14683",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4391",
  "meetings-icalendar-utils-lib": "static-1.888",
  "multi-currency-client-types": "static-1.3874",
  "object-builder-ui-client": "static-1.49547",
  "pipeline-validation-client-types": "static-1.4148",
  "smart-data-capture-core": "static-1.36",
  "smart-property-lib": "static-1.8177",
  "tiered-pricing": "static-1.1874",
  "topics-actions-lib": "static-1.416",
  "ui-addon-form-validation": "static-1.11238",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.263",
  "framework-data-schema-quick-fetch": "static-1.7049",
  "bend-plugin-pulse": "static-1.381",
  "event-emitter": "static-1.1206",
  "fast-json-patch": "static-1.67",
  "restore-request-side-panel-lib": "static-1.1564",
  "growth-data-modal": "static-1.5825",
  "growth-onboarding-confetti": "static-1.3313",
  "growth-onboarding-next-action-utils": "static-1.2603",
  "onboarding-tours-utils": "static-1.1112",
  "ui-shepherd-tracker": "static-1.7897",
  "academy-service-client": "static-1.3941",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39867",
  "SafeStorage": "static-1.4657",
  "video-embed": "static-1.36563",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24922",
  "viral-links-lib": "static-1.7326",
  "nested-table": "static-1.486",
  "timezone-utils": "static-2.5499",
  "getting-started-shared-tasks-store": "static-1.18242",
  "campaign-roi-lib": "static-1.10014",
  "ui-addon-calendars": "static-2.5581",
  "customer-data-views-management": "static-1.25942",
  "framework-data-table": "static-2.12455",
  "nudge-client-utils": "static-1.3075",
  "nudge-custom-ui-functions": "static-1.1426",
  "switchboard-lib": "static-1.467",
  "access-check-ui-lib": "static-1.1493",
  "app-users-service-client": "static-1.5871",
  "app-users-service-types": "static-1.5279",
  "mini-checkout-client": "static-1.27410",
  "onboarding-utils": "static-1.5614",
  "permissions-shared-i18n-strings-fe": "static-1.2118",
  "ui-coaching-tips-shared-config": "static-1.29208",
  "checkout-sdk": "static-3.24253",
  "payment-method-components": "static-1.7099",
  "touchless-buying-components": "static-1.6121",
  "upgrade-catalog-service-types": "static-1.3737",
  "edison-service-client-types": "static-1.645",
  "growth-onboarding-feedback-components": "static-1.6836",
  "audio-components": "static-1.6279",
  "FileManagerImages": "static-1.37519",
  "video-components": "static-1.14073",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92735",
  "customer-data-sidebar": "static-2.46651",
  "enrichment-properties-lib": "static-1.17823",
  "ui-addon-draggable-compat": "static-2.4515",
  "universal-record-utils-lib": "static-1.1754",
  "commerce-billing-lib": "static-1.20002",
  "commerce-shared-components-lib": "static-1.19136",
  "commerce-tools-ui-lib": "static-1.10966",
  "crm-fe-perf": "static-1.23152",
  "calling-error-reporting": "static-1.31576",
  "shared-worker-versioning": "static-1.11293",
  "calling-usage-tracker": "static-1.6791",
  "voice-sms-access-library": "static-1.1921",
  "commerce-permissions": "static-1.1028",
  "products-iframe-lib": "static-1.8505",
  "products-ui-components-shared-msw-handlers": "static-1.10916",
  "crm-index-associations-lib": "static-1.6696",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10617",
  "sales-views-client-types": "static-1.4509",
  "bark-lib": "static-1.16758",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.580",
  "policy-lib": "static-1.7047",
  "react-tinymce": "static-1.55886",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10680",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55012",
  "tinymce-plugins": "static-1.58126",
  "tinymce-themes": "static-1.56982",
  "onboarding-data-sync-lib": "static-1.2420",
  "growth-onboarding-next-action-components": "static-1.2631",
  "user-context-client": "static-1.4760",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4784",
  "outpost": "static-1.4412",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22092",
  "sales-email-signature-service-client": "static-1.4097",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6536",
  "crm-view-components": "static-1.1008",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7582",
  "nudge-custom-function-registry": "static-1.2832",
  "nudge-renderer-utils": "static-1.3151",
  "whisper-core-api": "static-1.7239",
  "InboxConnectUtils": "static-4.15467",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46756",
  "hub-http-rxjs": "static-1.834",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4244",
  "company-details-components": "static-1.6453",
  "react-performance-metrics-lib": "static-1.807",
  "pricing-pages-ui-components": "static-1.15511",
  "quote-checkout-service-types": "static-1.3711",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22431",
  "customer-data-email": "static-1.18459",
  "card-payment-highlight-lib": "static-1.37880",
  "card-subscription-highlight-lib": "static-1.40110",
  "commerce-contract-lib": "static-1.13169",
  "invoices-highlight-card-lib": "static-1.55564",
  "orders-highlight-card-lib": "static-1.22101",
  "products-highlight-card-lib": "static-1.18700",
  "quotes-highlight-card-lib": "static-1.72748",
  "crm-source-interpretation-lib": "static-1.5584",
  "data-agent-utils": "static-1.218",
  "crm-object-search-query-utilities": "static-1.10120",
  "utility-belt": "static-1.2783",
  "payments-enrollment-embed-lib": "static-1.23711",
  "stripe-embedded-components": "static-1.7932",
  "customer-data-rte": "static-1.33568",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6199",
  "payments-post-enroll-local-storage-lib": "static-1.5358",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38838",
  "calling-orchestration-schema": "static-1.36698",
  "react-reducer-toolkit": "static-1.16276",
  "hub-http-contrib": "static-1.3291",
  "interframe": "static-3.5008",
  "tinymce-data": "static-1.41097",
  "ui-addon-sales-email": "static-1.5466",
  "layout-dnd-components": "static-1.12898",
  "layout-dnd-utils": "static-1.11873",
  "ui-brand-identity-lib": "static-1.16234",
  "NamespacedHubStyle": "static-2.9228",
  "meetings-connect-utils-lib": "static-1.7861",
  "access-control-lib": "static-1.10689",
  "EmailComponents": "static-1.55463",
  "EmailData": "static-1.54141",
  "redux-less": "static-2.9731",
  "company-details-service-types": "static-1.4191",
  "segments-query-core": "static-1.1676",
  "pricing-pages-api": "static-1.15376",
  "sequences-lib": "static-1.8472",
  "ui-gdpr-components": "static-1.10607",
  "products-ui-components": "static-1.40935",
  "accounting-integrations-ui-components": "static-1.7473",
  "invoices-ui-lib": "static-1.55580",
  "commerce-products-api": "static-1.2641",
  "invoices-iframe-lib": "static-1.57638",
  "quotes-modal-lib": "static-1.103426",
  "quotes-ui-lib": "static-1.81469",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28831",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10198",
  "ContentComponents": "static-2.72019",
  "marketing-contacts-lib": "static-1.10911",
  "marketing-email-service-types": "static-1.2065",
  "messaging-editing-lib": "static-1.47040",
  "messaging-usage-based-billing-components-lib": "static-1.1902",
  "automation-ui-source-apps": "static-1.19572",
  "automation-ui-types": "static-1.20490",
  "messaging-types-lib": "static-1.46777",
  "onboarding-settings-client": "static-1.4762",
  "sequences-client-types-lib": "static-1.8329",
  "commerce-tax-lib": "static-1.792",
  "price-books-api": "static-1.1640",
  "price-books-components": "static-1.1698",
  "property-description-translator": "static-1.4092",
  "ramp-editor": "static-1.808",
  "commerce-analytics-service-client": "static-1.3767",
  "totals-ui-components": "static-1.24214",
  "SalesContentIndexUI": "static-3.9573",
  "advanced-menus-core": "static-1.15516",
  "advanced-menus-lib": "static-1.12396",
  "ui-memberships-settings-lib": "static-1.34746",
  "automation-ui-ubb": "static-1.6406",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7589",
  "data-token-views": "static-1.16801",
  "forms-utils-lib": "static-1.13026",
  "payments-embed-points-lib": "static-1.13516",
  "simple-menus-core": "static-1.15515",
  "simple-menus-lib": "static-1.17032",
  "videoconference-integration-components": "static-1.7182",
  "marketing-contacts-client": "static-1.7761",
  "mc-hard-limits-client-types": "static-1.155",
  "automation-applications-service-types": "static-1.3648",
  "automation-platform-service-types": "static-1.2659",
  "ContentEditorUI": "static-2.77812",
  "short-messages-app-service-client": "static-1.4170",
  "web-interactives-components": "static-1.14181",
  "web-interactives-data": "static-1.14182",
  "messaging-shared-utils-lib": "static-1.1351",
  "messaging-user-info-utils-lib": "static-1.1521",
  "email-portal-health-service-types": "static-1.1230",
  "line-items-api": "static-1.1040",
  "commerce-totals-service-types": "static-1.3997",
  "FireAlarmUi": "static-1.4685",
  "sales-templates-service-types-lib": "static-1.4349",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22426",
  "automation-ui-usage-tracking": "static-1.21889",
  "data-studio-ubb": "static-1.3421",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27572",
  "content-management-data-lib": "static-1.5880",
  "copilot-plugins": "static-1.11727",
  "cta-picker": "static-1.37002",
  "customer-agent-discovery-components-lib": "static-1.3789",
  "editor-components": "static-1.13584",
  "editor-iframe-lib": "static-1.8738",
  "error-messaging-js": "static-1.5448",
  "FormsCommonComponents": "static-1.86478",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10901",
  "SharedLegalStrings": "static-1.1998",
  "smart-content-core": "static-1.43087",
  "smart-content-lib": "static-1.43740",
  "social-composer-lib": "static-1.60100",
  "structured-content-lib": "static-1.25831",
  "theme-previewer-lib": "static-1.53860",
  "tinymce-copilot": "static-1.17080",
  "xray-recommendation-lib": "static-1.8211",
  "automation-ui-routing": "static-1.21847",
  "sql-reporting-client-types": "static-1.5853",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42707",
  "campaigns-utils-lib": "static-1.3454",
  "reporting-enablement": "static-1.23728",
  "forms-ai-lib": "static-1.4694",
  "codemirror-dlb": "static-1.59371",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6691",
  "report-customization-components": "static-1.13812",
  "data-quality-ui-library": "static-1.13691",
  "reporting-filters": "static-1.921",
  "reporting-insights-lib": "static-1.2475"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13130",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.491",
  "data-fetching-client": "/data-fetching-client/static-1.9908",
  "foundations-components": "/foundations-components/static-1.8394",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1419",
  "foundations-theming": "/foundations-theming/static-1.4711",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8278",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10534",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11735",
  "I18n": "/I18n/static-7.1663",
  "jasmine-runner": "/jasmine-runner/static-1.6700",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.558",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13193",
  "quartz": "/quartz/static-1.7375",
  "react-dlb": "/react-dlb/static-1.85",
  "react-rhumb": "/react-rhumb/static-1.16963",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3107",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10542",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12773",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7566",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11396",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9789",
  "unified-auth": "/unified-auth/static-1.814",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1096",
  "usage-tracker": "/usage-tracker/static-1.7608",
  "usage-tracker-core": "/usage-tracker-core/static-1.7458",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8350",
  "hub-http": "/hub-http/static-1.6465",
  "integrations-lib": "/integrations-lib/static-1.16936",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20614",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.600",
  "property-management-iframe": "/property-management-iframe/static-1.14006",
  "quartz-config": "/quartz-config/static-1.1153",
  "quartz-core": "/quartz-core/static-1.6594",
  "quartz-routing": "/quartz-routing/static-1.805",
  "quick-fetch": "/quick-fetch/static-1.4098",
  "react": "/react/static-7.191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4915",
  "ts-schema": "/ts-schema/static-1.4259",
  "ui-universal-auth": "/ui-universal-auth/static-1.9300",
  "UIComponents": "/UIComponents/static-3.8681",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3582",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3652",
  "quartz-webpack": "/quartz-webpack/static-1.3599",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.453",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4663",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-assets": "/foundations-assets/static-1.5131",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2427",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9678",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5520",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2486",
  "ui-fonts": "/ui-fonts/static-1.997",
  "ui-images": "/ui-images/static-2.1230",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3194",
  "foundations-theming-base": "/foundations-theming-base/static-1.3696",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.790",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3389",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4569",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8955",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9601",
  "ai-rendering-library": "/ai-rendering-library/static-1.11012",
  "chirp-fetch": "/chirp-fetch/static-1.2144",
  "connections-embed-lib": "/connections-embed-lib/static-1.1435",
  "copilot-toolkit": "/copilot-toolkit/static-1.11755",
  "feedback-loader": "/feedback-loader/static-1.29740",
  "laboratory-lib": "/laboratory-lib/static-3.7404",
  "marketplace-embed": "/marketplace-embed/static-1.22828",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10509",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20569",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14784",
  "sanitize-text": "/sanitize-text/static-1.8402",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6022",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5294",
  "wootric-nps": "/wootric-nps/static-1.7165",
  "quartz-head": "/quartz-head/static-1.1040",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4910",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4403",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "reporting-data": "/reporting-data/static-1.68609",
  "cssUtils": "/cssUtils/static-1.872",
  "flux-actions": "/flux-actions/static-1.360",
  "HubStyle": "/HubStyle/static-2.12042",
  "PatternValidationJS": "/PatternValidationJS/static-1.3149",
  "react-colorpicker": "/react-colorpicker/static-2.10460",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10618",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7598",
  "icons": "/icons/static-2.674",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19146",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4763",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5877",
  "quartz-i18n": "/quartz-i18n/static-1.1050",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.362",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1081",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.939",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.32",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.383",
  "slack-ui-library": "/slack-ui-library/static-1.10650",
  "fsm": "/fsm/static-1.3992",
  "customer-data-objects": "/customer-data-objects/static-1.7938",
  "property-translator": "/property-translator/static-1.5648",
  "hs-locale-management": "/hs-locale-management/static-1.259",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8180",
  "hs-promise-utils": "/hs-promise-utils/static-1.5849",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5131",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14351",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5860",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8029",
  "sanitize": "/sanitize/static-1.4728",
  "superstore": "/superstore/static-1.5009",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10516",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8263",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4829",
  "immutable-less": "/immutable-less/static-1.4903",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18021",
  "nav-meta": "/nav-meta/static-1.30358",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18324",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.889",
  "ai-studio-lib": "/ai-studio-lib/static-1.12368",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18880",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.408",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9327",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8278",
  "ui-product-approvals": "/ui-product-approvals/static-1.28994",
  "ui-tool-access": "/ui-tool-access/static-1.10405",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4023",
  "property-management-common": "/property-management-common/static-1.6294",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.567",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1050",
  "quartz-test": "/quartz-test/static-1.1050",
  "quartz-tracking": "/quartz-tracking/static-1.754",
  "trellis-components": "/trellis-components/static-1.2505",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.325",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22667",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13281",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2749",
  "breeze-engine-core": "/breeze-engine-core/static-1.860",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.624",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40775",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13432",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15382",
  "ExportDialog": "/ExportDialog/static-6.10631",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41923",
  "reporting-snowflake": "/reporting-snowflake/static-1.57227",
  "reporting-ui-components": "/reporting-ui-components/static-2.65880",
  "reporting-visualizations": "/reporting-visualizations/static-1.60685",
  "trial-components-library": "/trial-components-library/static-1.14029",
  "trellis-theming": "/trellis-theming/static-1.1215",
  "ui-addon-teams": "/ui-addon-teams/static-1.21857",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.460",
  "magpie-lib": "/magpie-lib/static-1.5722",
  "navigation-components": "/navigation-components/static-1.18721",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1582",
  "magpie-types": "/magpie-types/static-1.5182",
  "simple-logging-lib": "/simple-logging-lib/static-1.3303",
  "fail-safe": "/fail-safe/static-1.207",
  "app-governance-lib": "/app-governance-lib/static-1.2303",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10753",
  "purchase-motions-components": "/purchase-motions-components/static-1.6289",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10056",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6025",
  "usage-tracker-public": "/usage-tracker-public/static-1.7419",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3951",
  "reference-resolvers": "/reference-resolvers/static-1.8433",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4173",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.590",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3261",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3444",
  "atom": "/atom/static-1.5338",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.99",
  "react-codemirror": "/react-codemirror/static-1.10891",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5007",
  "content-assistance-lib": "/content-assistance-lib/static-1.8139",
  "content-media-capture": "/content-media-capture/static-1.5321",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10079",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24368",
  "growth-payments-core": "/growth-payments-core/static-1.26083",
  "knowledge-content-types": "/knowledge-content-types/static-1.8621",
  "payment-link-components": "/payment-link-components/static-1.24087",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20241",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10136",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9335",
  "video-components-external": "/video-components-external/static-1.12071",
  "video-data-lib": "/video-data-lib/static-1.35729",
  "navigation-messaging": "/navigation-messaging/static-1.8048",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58621",
  "react-dnd-compat": "/react-dnd-compat/static-1.4867",
  "batch-promise": "/batch-promise/static-1.1794",
  "crm-component-utils": "/crm-component-utils/static-1.39741",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6142",
  "customer-data-properties": "/customer-data-properties/static-1.52448",
  "external-options-client-types": "/external-options-client-types/static-1.4305",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7144",
  "property-value-citations": "/property-value-citations/static-1.3062",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8352",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10532",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5067",
  "content-icons-ui": "/content-icons-ui/static-1.2316",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.201",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.787",
  "pulse": "/pulse/static-1.878",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7500",
  "crm-message-bus": "/crm-message-bus/static-1.43651",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23210",
  "events-data-lib": "/events-data-lib/static-1.494",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4978",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4186",
  "hs-resources": "/hs-resources/static-1.443",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1247",
  "onboarding-scopes": "/onboarding-scopes/static-1.6707",
  "onboarding-tours": "/onboarding-tours/static-1.17046",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14377",
  "academy-common-lib": "/academy-common-lib/static-1.14842",
  "dashboard-lib": "/dashboard-lib/static-1.82642",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19124",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18872",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8957",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11348",
  "user-context": "/user-context/static-1.5366",
  "reporting-plugins": "/reporting-plugins/static-1.10674",
  "reporting-reports": "/reporting-reports/static-1.68287",
  "hubs-service-types": "/hubs-service-types/static-1.1510",
  "purchase-motions-api": "/purchase-motions-api/static-1.6292",
  "signup-constants": "/signup-constants/static-1.19513",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.973",
  "nest": "/nest/static-1.487",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.560",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.158",
  "framework-listing-lib": "/framework-listing-lib/static-2.29386",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31340",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8312",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5260",
  "one-click-checkout": "/one-click-checkout/static-1.315",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7853",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15206",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9998",
  "redux-thunk": "/redux-thunk/static-2.77",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29223",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13125",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4677",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.634",
  "ui-addon-opt": "/ui-addon-opt/static-4.8617",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6542",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5333",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3779",
  "data-token-picker": "/data-token-picker/static-1.16820",
  "FileManagerLib": "/FileManagerLib/static-1.40008",
  "content-media-compositions": "/content-media-compositions/static-2.17132",
  "media-bridge-lib": "/media-bridge-lib/static-1.19343",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22658",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3418",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7121",
  "card-properties-lib": "/card-properties-lib/static-1.44913",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37687",
  "crm-actions": "/crm-actions/static-1.6604",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44395",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9861",
  "customer-data-tracking": "/customer-data-tracking/static-1.7133",
  "calling-global-api": "/calling-global-api/static-1.65387",
  "calling-internal-common": "/calling-internal-common/static-1.31569",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66769",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59063",
  "commerce-products-lib": "/commerce-products-lib/static-1.10417",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3980",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4482",
  "crm-links": "/crm-links/static-1.6576",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4314",
  "formula-editor": "/formula-editor/static-1.14683",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4391",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.888",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3874",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49547",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4148",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.36",
  "smart-property-lib": "/smart-property-lib/static-1.8177",
  "tiered-pricing": "/tiered-pricing/static-1.1874",
  "topics-actions-lib": "/topics-actions-lib/static-1.416",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11238",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.263",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7049",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.381",
  "event-emitter": "/event-emitter/static-1.1206",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1564",
  "growth-data-modal": "/growth-data-modal/static-1.5825",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3313",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2603",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1112",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7897",
  "academy-service-client": "/academy-service-client/static-1.3941",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39867",
  "SafeStorage": "/SafeStorage/static-1.4657",
  "video-embed": "/video-embed/static-1.36563",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24922",
  "viral-links-lib": "/viral-links-lib/static-1.7326",
  "nested-table": "/nested-table/static-1.486",
  "timezone-utils": "/timezone-utils/static-2.5499",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18242",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10014",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5581",
  "customer-data-views-management": "/customer-data-views-management/static-1.25942",
  "framework-data-table": "/framework-data-table/static-2.12455",
  "nudge-client-utils": "/nudge-client-utils/static-1.3075",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1426",
  "switchboard-lib": "/switchboard-lib/static-1.467",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1493",
  "app-users-service-client": "/app-users-service-client/static-1.5871",
  "app-users-service-types": "/app-users-service-types/static-1.5279",
  "mini-checkout-client": "/mini-checkout-client/static-1.27410",
  "onboarding-utils": "/onboarding-utils/static-1.5614",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2118",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29208",
  "checkout-sdk": "/checkout-sdk/static-3.24253",
  "payment-method-components": "/payment-method-components/static-1.7099",
  "touchless-buying-components": "/touchless-buying-components/static-1.6121",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3737",
  "edison-service-client-types": "/edison-service-client-types/static-1.645",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6836",
  "audio-components": "/audio-components/static-1.6279",
  "FileManagerImages": "/FileManagerImages/static-1.37519",
  "video-components": "/video-components/static-1.14073",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92735",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46651",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17823",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4515",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1754",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20002",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19136",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10966",
  "crm-fe-perf": "/crm-fe-perf/static-1.23152",
  "calling-error-reporting": "/calling-error-reporting/static-1.31576",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11293",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6791",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1921",
  "commerce-permissions": "/commerce-permissions/static-1.1028",
  "products-iframe-lib": "/products-iframe-lib/static-1.8505",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10916",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6696",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10617",
  "sales-views-client-types": "/sales-views-client-types/static-1.4509",
  "bark-lib": "/bark-lib/static-1.16758",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.580",
  "policy-lib": "/policy-lib/static-1.7047",
  "react-tinymce": "/react-tinymce/static-1.55886",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10680",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55012",
  "tinymce-plugins": "/tinymce-plugins/static-1.58126",
  "tinymce-themes": "/tinymce-themes/static-1.56982",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2420",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2631",
  "user-context-client": "/user-context-client/static-1.4760",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4784",
  "outpost": "/outpost/static-1.4412",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22092",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4097",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6536",
  "crm-view-components": "/crm-view-components/static-1.1008",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7582",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2832",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3151",
  "whisper-core-api": "/whisper-core-api/static-1.7239",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15467",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46756",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.834",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4244",
  "company-details-components": "/company-details-components/static-1.6453",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.807",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15511",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3711",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22431",
  "customer-data-email": "/customer-data-email/static-1.18459",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37880",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40110",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13169",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55564",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22101",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18700",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72748",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5584",
  "data-agent-utils": "/data-agent-utils/static-1.218",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10120",
  "utility-belt": "/utility-belt/static-1.2783",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23711",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7932",
  "customer-data-rte": "/customer-data-rte/static-1.33568",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6199",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5358",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38838",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36698",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16276",
  "hub-http-contrib": "/hub-http-contrib/static-1.3291",
  "interframe": "/interframe/static-3.5008",
  "tinymce-data": "/tinymce-data/static-1.41097",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5466",
  "layout-dnd-components": "/layout-dnd-components/static-1.12898",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11873",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16234",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9228",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7861",
  "access-control-lib": "/access-control-lib/static-1.10689",
  "EmailComponents": "/EmailComponents/static-1.55463",
  "EmailData": "/EmailData/static-1.54141",
  "redux-less": "/redux-less/static-2.9731",
  "company-details-service-types": "/company-details-service-types/static-1.4191",
  "segments-query-core": "/segments-query-core/static-1.1676",
  "pricing-pages-api": "/pricing-pages-api/static-1.15376",
  "sequences-lib": "/sequences-lib/static-1.8472",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10607",
  "products-ui-components": "/products-ui-components/static-1.40935",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7473",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55580",
  "commerce-products-api": "/commerce-products-api/static-1.2641",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57638",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103426",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81469",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28831",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10198",
  "ContentComponents": "/ContentComponents/static-2.72019",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10911",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2065",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47040",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1902",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19572",
  "automation-ui-types": "/automation-ui-types/static-1.20490",
  "messaging-types-lib": "/messaging-types-lib/static-1.46777",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4762",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8329",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.792",
  "price-books-api": "/price-books-api/static-1.1640",
  "price-books-components": "/price-books-components/static-1.1698",
  "property-description-translator": "/property-description-translator/static-1.4092",
  "ramp-editor": "/ramp-editor/static-1.808",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3767",
  "totals-ui-components": "/totals-ui-components/static-1.24214",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9573",
  "advanced-menus-core": "/advanced-menus-core/static-1.15516",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12396",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34746",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6406",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7589",
  "data-token-views": "/data-token-views/static-1.16801",
  "forms-utils-lib": "/forms-utils-lib/static-1.13026",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13516",
  "simple-menus-core": "/simple-menus-core/static-1.15515",
  "simple-menus-lib": "/simple-menus-lib/static-1.17032",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7182",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7761",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.155",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3648",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2659",
  "ContentEditorUI": "/ContentEditorUI/static-2.77812",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4170",
  "web-interactives-components": "/web-interactives-components/static-1.14181",
  "web-interactives-data": "/web-interactives-data/static-1.14182",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1351",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1521",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1230",
  "line-items-api": "/line-items-api/static-1.1040",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3997",
  "FireAlarmUi": "/FireAlarmUi/static-1.4685",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4349",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22426",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21889",
  "data-studio-ubb": "/data-studio-ubb/static-1.3421",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27572",
  "content-management-data-lib": "/content-management-data-lib/static-1.5880",
  "copilot-plugins": "/copilot-plugins/static-1.11727",
  "cta-picker": "/cta-picker/static-1.37002",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3789",
  "editor-components": "/editor-components/static-1.13584",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8738",
  "error-messaging-js": "/error-messaging-js/static-1.5448",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10901",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1998",
  "smart-content-core": "/smart-content-core/static-1.43087",
  "smart-content-lib": "/smart-content-lib/static-1.43740",
  "social-composer-lib": "/social-composer-lib/static-1.60100",
  "structured-content-lib": "/structured-content-lib/static-1.25831",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53860",
  "tinymce-copilot": "/tinymce-copilot/static-1.17080",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8211",
  "automation-ui-routing": "/automation-ui-routing/static-1.21847",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5853",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42707",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3454",
  "reporting-enablement": "/reporting-enablement/static-1.23728",
  "forms-ai-lib": "/forms-ai-lib/static-1.4694",
  "codemirror-dlb": "/codemirror-dlb/static-1.59371",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6691",
  "report-customization-components": "/report-customization-components/static-1.13812",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13691",
  "reporting-filters": "/reporting-filters/static-1.921",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2475"
}
};
